import React from 'react';

const FeesSection = () => {
  return (
    <div className="price-list-medicalform">
      <div className="row">
        <div className="col-xl-10 offset-xl-1 col-lg-10 offset-lg-1">
          <div className="section-title text-center pos-rel mb-75">
            <div className="section-icon">
              {/* <img className="section-back-icon" src="img/section/section-back-icon.png" alt="" /> */}
            </div>
            <div className="section-text pos-rel">
              <h2>Price List</h2>
            </div>
            <div className="section-line pos-rel">
              <img src="img/shape/section-title-line.png" alt="" />
            </div>
          </div>
        </div>
      </div>

      <div className="fee-item">
        <div className="bottom-line"></div>

        <table className="table table-striped table-hover">
          <thead>
            <tr>
              <th className="table-hover" scope="col">Form Type</th>
              <th className="table-hover" scope="col">Price</th>
            </tr>
          </thead>
          <tbody>
            <tr className="table-hover">
              <td>First page</td>
              <td>$250 <span className="note">including GST</span></td>
            </tr>
            <tr className="table-hover">
              <td>Additional Page (2-99 pages)</td>
              <td>$75 each <span className="note">including GST</span></td>
            </tr>
            <tr className="table-hover">
              <td>Disability Form</td>
              <td>$750 <span className="note">including GST</span></td>
            </tr>
          </tbody>
        </table>
        <p className="mt-3 text-center"><strong>Note:</strong> Form completion is not covered by MSP. Fees vary depending on complexity and will be confirmed before we begin.</p>
      </div>
    </div>
  );
};

export default FeesSection;